// Decisión única del régimen de subsidio por descanso médico (gemelo JS de SubsidyRegimeHelper del backend).
// Régimen "subsidio total sin período de empleador" (no consume el contador de 20 días):
//   - MATERNIDAD: subsidio EsSalud desde el día 1 (incondicional).
//   - ACCIDENTE_LABORAL con SCTR-Salud: subsidio SCTR desde el día 1 (Regla D).
// El resto (ENFERMEDAD, ACCIDENTE_COMUN, ACCIDENTE_LABORAL sin SCTR) es régimen común: primeros 20 días
// a cargo del empleador, día 21+ EsSalud.

export function isFullSubsidyNoEmployer(leaveType, hasSctrHealth) {
  if (leaveType === 'MATERNIDAD') return true
  return leaveType === 'ACCIDENTE_LABORAL' && hasSctrHealth === true
}

export function participatesInEmployerCounter(leaveType, hasSctrHealth) {
  return !isFullSubsidyNoEmployer(leaveType, hasSctrHealth)
}
